<template>
  <div class="workOrder">
    <div class="workOrder-wrap">
      <h1 class="personal-center-form__title">工单咨询</h1>
      <div class="container">
        <div>
          <el-form :inline="true"  class="demo-form-inline"  @submit.native.prevent>
            <el-form-item label="工单Id">
              <el-input v-model="formSearch.userRepairOrderId" clearable style="width:150px"></el-input>
            </el-form-item>
            <el-form-item label="订单标题">
              <el-input v-model="formSearch.orderTitle" clearable style="width:150px"></el-input>
            </el-form-item>
            <el-form-item label="状态">
              <el-select v-model="formSearch.orderState" placeholder="请选择" clearable style="width:150px" @change="search">
                <el-option
                  v-for="(value, key) in stateMap"
                  :key="key"
                  :label="value"
                  :value="key">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item>
            <el-button type="primary"
                      class="search-btn"
                      @click="search">查询</el-button>
            <el-button type="primary"
                      class="search-btn"
                      @click="dialogFormVisibleOrder = true">新建工单</el-button>
          </el-form-item>
          </el-form>
          <el-table :data="workIfoList" style="width: 100%">
            <el-table-column prop="userRepairOrderId" label="工单id" align="center" min-width="60"></el-table-column>
            <el-table-column prop="orderTitle" label="工单标题" align="center" min-width="60"></el-table-column>
            <el-table-column prop="createtime" label="工单创建时间" align="center" min-width="60"></el-table-column>
            <el-table-column label="工单更新时间" align="center" min-width="60">
              <template slot-scope="scope">
                {{scope.row.updatetime || '暂无'}}
              </template>
            </el-table-column>
            <!-- <el-table-column prop="createBy" label="工单创建人id" align="center" min-width="40"></el-table-column> -->
            <!-- <el-table-column prop="customerName" label="工单创建人名称" align="center" min-width="40"></el-table-column> -->
            <el-table-column label="工单状态" align="center" min-width="40">
              <template slot-scope="scope">
                {{stateMap[scope.row.orderState]}}
              </template>
            </el-table-column>
            <el-table-column label="操作" align="center" min-width="40">
              <template slot-scope="scope">
                <el-button @click="handleClick(scope.row)" type="text" size="small">查看</el-button>
                <el-button @click="deleteClick(scope.row)" type="text" size="small">关闭</el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div class="block">
          <el-pagination
            v-if="workIfoList.length > 0"
            @current-change="handleCurrentChange"
            :current-page="currentPage"
            :page-size="10"
            layout="total, prev, pager, next"
            :total="totalCount">
          </el-pagination>
        </div>
      </div>
    </div>
    <confirm-modal :show="isDeleteWorkOrder" content="是否确定关闭该条工单？" 
                   @cancel-click="isDeleteWorkOrder = false" @confirm-click="deleteWorkOrder"></confirm-modal>
    <el-dialog title="新建工单" :visible.sync="dialogFormVisibleOrder">
      <el-form :model="addOrderForm" :rules="rules" ref="addOrderForm" class="work_order_add">
        <el-form-item label="工单标题：" :label-width="formLabelWidth" prop="orderTitle">
          <el-input v-model="addOrderForm.orderTitle" auto-complete="off"  width="100px"></el-input>
        </el-form-item>
        <el-form-item label="工单内容：" :label-width="formLabelWidth" class="el-order-height" prop="orderContent">
          <el-input type="textarea" :rows="4" v-model="addOrderForm.orderContent" auto-complete="off"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisibleOrder = false">取 消</el-button>
        <el-button type="primary" @click="submitForm('addOrderForm')">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { mapGetters, mapActions, mapMutations } from 'vuex';
import * as types from '../../vuex/types';
import confirmModal from '../common/Confirm.vue';
import workApi from '../../api/work';

export default {
  data() {
    return {
      isDeleteWorkOrder: false,
      workIfoList: [],
      totalCount: 0,
      currentPage: 1,
      stateMap: {
        1: "待处理",
        2: "已处理",
        3: "已关闭",
      },
      formSearch: {
        userRepairOrderId: '',
        orderTitle: '',
        orderState: '',
        pageNum: 1,
        pageSize: 10
      },
      dialogFormVisibleOrder: false,
      addOrderForm: {
        orderTitle: '',
        orderContent: ''
      },
      rules: {
        orderTitle: [{ 
          required: true, 
          trigger: "blur",
          validator: (rule, value, callback) => {
            if (_.trim(value) === '') {
                callback(new Error('请输入工单标题'));
              } else if (value.length >= 50) {
                callback(new Error('工单标题最多输入50个字符！'));
              } else {
                callback();
              }
            }
          }],
        orderContent: [{ 
          required: true, 
          trigger: "blur",
          validator: (rule, value, callback) => {
            if (_.trim(value) === '') {
                callback(new Error('请输入工单内容'));
              } else if (value.length >= 140) {
                callback(new Error('工单内容最多输入140个字符！'));
              } else {
                callback();
              }
            }
          }]
      },
      formLabelWidth: '200px'
    };
  },
  components: {
    confirmModal
  },
  created() {
    this.fetchData()
  },
  methods: {
    handleClick(row) {
      this.$router.push({
        path: '/personalCenter/workOrderdetails',
        query: {
          userRepairOrderId: row.userRepairOrderId
        }
      });
    },
    search () {
      this.formSearch.pageNum = 1
      this.currentPage = 1
      this.fetchData()
    },
    handleCurrentChange(val) {
      this.currentPage = val
      this.formSearch.pageNum = val
      this.fetchData();
    },
    fetchData() {
      workApi.myUserRepairOrderlist({
        ...this.formSearch,
        tokenId: localStorage.getItem('dl_tokenId_bl'),
        }).then(res => {
        if (res.code === 0) {
          this.workIfoList = res.result.content
          this.totalCount = parseFloat(res.result.totalElements)
        } else {
          this.setFailMessage({
            show: true,
            content: res.msg || '获取失败'
          });
        }
      }).catch(err => {
        this.setFailMessage({
          show: true,
          content: err.msg || '获取失败'
        });
        console.log('err', err)
      })
    },
    ...mapActions({
      getLoanAllData: types.GET_LOAN_ALL_DATA,
      signAture: types.SIGN_AGREEMENT,
      downContract: types.DOWN_AGREEMENT,
      setSuccessMessage: types.SET_SUCCESS_MESSAGE,
      setFailMessage: types.SET_FAIL_MESSAGE
    }),
    ...mapMutations({
      setLoanAllData: types.SET_LOAN_ALL_DATA,
      setSuccessModal: types.SET_SUCCESS_MESSAGE_STATE,
      setFailModal: types.SET_FAIL_MESSAGE_STATE,
      setSigned: types.SET_SIGNED
    }),
    //添加工单
    addUserRepairOrder() {
      workApi.addUserRepairOrder({
        ...this.addOrderForm
      }).then(res => {
        if (res.code === 0) {
          this.setSuccessMessage({
            show: true,
            content: res.msg || "添加成功"
          });
          setTimeout(() => {
            window.location.reload()
          }, 500)
        } else {
          this.setFailMessage({
            show: true,
            content: res.msg || "添加失败"
          });
        }
      }).catch(err => {
        this.setFailMessage({
          show: true,
          content: err.msg || "添加失败"
        });
        console.log("err", err);
      });
    },
    deleteClick(val) {
      if (val.orderState === 3) {
        this.setSuccessMessage({
          show: true,
          content: "该工单已关闭，请不要重复关闭，谢谢！"
        })
        return false
      }
      this.formSearch.userRepairOrderId = val.userRepairOrderId
      this.isDeleteWorkOrder = true
    },
    // 添加工单
    submitForm(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          this.addUserRepairOrder()
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    // 删除工单
    deleteWorkOrder() {
      workApi.downUserReplyOrder({
        userRepairOrderId: this.formSearch.userRepairOrderId
      }).then(res => {
        if (res.code === 0) {
          this.setSuccessMessage({
            show: true,
            content: res.msg || "删除成功"
          });
          setTimeout(() => {
            window.location.reload()
          }, 500)
        } else {
          this.setFailMessage({
            show: true,
            content: res.msg || "删除失败"
          });
        }
      }).catch(err => {
        this.setFailMessage({
          show: true,
          content: err.msg || "删除失败"
        });
        console.log("err", err);
      });
    }
  },
};
</script>
<style lang="scss">
.workOrder {
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  box-sizing: border-box;
  margin-top: 15px;
  padding-left: 30px;
  .container {
    // width: 1170px;
    padding-right: 15px;
    padding-left: 15px;
    margin-right: auto;
    margin-left: auto;
    padding-top: 20px;
    padding-bottom: 75px;
    background-color: #fff;
  }
}
.work_order_add .el-input__inner,
.work_order_add .el-textarea__inner{
  width: 400px !important;
}
.work_order_add .el-form-item{
  height: initial !important;
}
.work_order_add .el-order-height{
  margin-bottom: 0 !important;
}
</style>



// WEBPACK FOOTER //
// workOrder.vue?53e909ae